import log from '@pexip/logger';

export const logger = log.child({name: 'config-manager'});
